// extracted by mini-css-extract-plugin
export default {"resetPasswordButton":"resetPasswordButton---JOFkC"};